import Games from './Games.js';

export default class Hunter extends Games {

    rules(user, productScan) {

    }

    point(conditions) {

    }
}
